import { CHECK_LOGIN, LOGIN_USER_SUCCESSFUL, API_ERROR,LOGOUT_USER, LOGOUT_USER_SUCCESS, VERIFY_ADMIN, VERIFY_ADMIN_SUCCESS, VERIFY_ADMIN_FAIL, RESET_STATE } from './actionTypes';

export const checkLogin = (user, history) => {
    return {
        type: CHECK_LOGIN,
        payload: { user, history }
    }
}

export const loginUserSuccessful = (user) => {
    return {
        type: LOGIN_USER_SUCCESSFUL,
        payload: user
    }
}

export const apiError = (error) => {
    return {
        type: API_ERROR,
        payload: error
    }
}

export const logoutUser = (history) => {
    return {
        type: LOGOUT_USER,
        payload: { history }
    }
}

export const logoutUserSuccess = () => {
    return {
        type: LOGOUT_USER_SUCCESS,
        payload: {}
    }
}

export const verify_admin = (user) => {
    return {
        type: VERIFY_ADMIN,
        payload: {user}
    }
}
export const verify_adminSuccess = (user) => {
    return {
        type: VERIFY_ADMIN_SUCCESS,
        payload: {user}
    }
}
export const verify_adminFail = (user) => {
    return {
        type: VERIFY_ADMIN_FAIL,
        payload: {user}
    }
}

export const resetLoginState = () => {
    return {
         type: RESET_STATE,
         playload:{}
    }
}


